export default "__VITE_ASSET__841fed8e__"